<div class="app-toggle">
    <input (input)="onCheckboxChange($event)" (change)="onCheckboxChange($event)" [checked]="checked" [disabled]="disabled" [id]="id + '_toggle'" type="checkbox" />
    <label [for]="id + '_toggle'"></label>
</div>
